import React from 'react';
import { cn } from '../../lib/utils';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  variant?: 'navy' | 'charcoal';
  container?: boolean;
}
export function Section({
  children,
  className,
  variant = 'navy',
  container = true,
  ...props
}: SectionProps) {
  return <section className={cn('py-20 relative overflow-hidden', {
    'bg-navy-900': variant === 'navy',
    'bg-navy-800': variant === 'charcoal'
  }, className)} {...props} data-id="element-391">
      {/* Decorative grid lines for that tactical feel */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-392"></div>

      {container ? <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-393">
          {children}
        </div> : children}
    </section>;
}
export function SectionHeader({
  title,
  subtitle,
  className
}: {
  title: string;
  subtitle?: string;
  className?: string;
}) {
  return <div className={cn('mb-12 md:mb-16 border-l-4 border-gold-500 pl-6', className)} data-id="element-394">
      {subtitle && <p className="text-gold-500 font-heading tracking-widest text-sm uppercase mb-2" data-id="element-395">
          {subtitle}
        </p>}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-tight" data-id="element-396">
        {title}
      </h2>
    </div>;
}